import {
    REQUEST_WAREHOUSES,
    FETCH_WAREHOUSES_SUCCESS,
    FETCH_WAREHOUSES_FAILURE,
    RESET_WAREHOUSES,
    SELECT_WAREHOUSE,
    RESET_CURRENT_WAREHOUSE,
    REQUEST_WAREHOUSE_DETAIL,
    FETCH_WAREHOUSE_DETAIL_SUCCESS,
    FETCH_WAREHOUSE_DETAIL_FAILURE,
    REQUEST_CREATING_WAREHOUSE,
    CREATE_WAREHOUSE_SUCCESS,
    CREATE_WAREHOUSE_FAILURE,
    REQUEST_EDITING_WAREHOUSE,
    EDIT_WAREHOUSE_SUCCESS,
    EDIT_WAREHOUSE_FAILURE,
    REQUEST_WAREHOUSE_SALES_ORDERS,
    FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS,
    FETCH_WAREHOUSE_SALES_ORDERS_FAILURE,
    REQUEST_WAREHOUSE_PURCHASE_ORDERS,
    FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS,
    FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE,
    REQUEST_WAREHOUSE_BINS,
    FETCH_WAREHOUSE_BINS_SUCCESS,
    FETCH_WAREHOUSE_BINS_FAILURE,
    REQUEST_DELETE_WAREHOUSE,
    DELETE_WAREHOUSE_SUCCESS,
    DELETE_WAREHOUSE_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
    all: [],
    fetchWarehousesError: null,
    currentWarehouse: null,
    currentWarehouseDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    salesOrders: [],
    salesOrdersIsLoading: false,
    salesOrdersError: null,
    purchaseOrders: [],
    purchaseOrdersIsLoading: false,
    purchaseOrdersError: null,
    warehouseBinsDetail: null,
    warehouseBinsDetailIsLoading: false,
    warehouseBinsDetailError: null,
    deleteWarehouse: false,
    deleteWarehouseSuccess: null,
    deleteWarehouseError: null,


};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Warehouse action handlers
        case REQUEST_WAREHOUSES:
            return { ...state, fetchWarehousesError: null, isLoading: true };
        case FETCH_WAREHOUSES_SUCCESS:
            return { ...state, all: action.payload.data, updated: false, fetchWarehousesError: null, isLoading: false };
        case FETCH_WAREHOUSES_FAILURE:
            const fetchWarehousesError = action.payload || { message: action.payload.message };
            return { ...state, all: [], fetchWarehousesError, isLoading: false };
        case RESET_WAREHOUSES:
            return { ...state, all: [], updated: false, fetchWarehousesError: null, isLoading: false };
        case SELECT_WAREHOUSE:
            return { ...state, currentWarehouse: action.payload };
        case RESET_CURRENT_WAREHOUSE:
            return { ...state, currentWarehouse: null, currentWarehouseDetail: null };
        case REQUEST_WAREHOUSE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_WAREHOUSE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentWarehouseDetail: action.payload.data, detailError: null, detailIsLoading: false };
        case FETCH_WAREHOUSE_DETAIL_FAILURE:// return error and make loading = false
        const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
        return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_WAREHOUSE:
            return { ...state, isCreating: true, createError: null, created: false };
        case CREATE_WAREHOUSE_SUCCESS:
            return { ...state, isCreating: false, createError: null, created: true };
        case CREATE_WAREHOUSE_FAILURE:
            const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, createError: createError, created: false };
        case REQUEST_EDITING_WAREHOUSE:
            return { ...state, isEditing: true, editError: null, edited: false };
        case EDIT_WAREHOUSE_SUCCESS:
            return { ...state, updated: true, isEditing: false, editError: null, edited: true };
        case EDIT_WAREHOUSE_FAILURE:
            const editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isEditing: false, editError: editError, edited: false };
        case REQUEST_WAREHOUSE_SALES_ORDERS:
            return { ...state, salesOrdersIsLoading: true, salesOrdersError: null };
        case FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS:
            return { ...state, salesOrders: action.payload.data, salesOrdersIsLoading: false };
        case FETCH_WAREHOUSE_SALES_ORDERS_FAILURE:
            const salesOrdersError = action.payload.data || { message: action.payload.message };
            return { ...state, salesOrdersError: salesOrdersError, salesOrdersIsLoading: false };
        case REQUEST_WAREHOUSE_PURCHASE_ORDERS:
            return { ...state, purchaseOrdersIsLoading: true, purchaseOrdersError: null };
        case FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS:
            return { ...state, purchaseOrders: action.payload.data, purchaseOrdersIsLoading: false };
        case FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE:
            const purchaseOrdersError = action.payload.data || { message: action.payload.message };
            return { ...state, purchaseOrdersError: purchaseOrdersError, purchaseOrdersIsLoading: null };
        case REQUEST_WAREHOUSE_BINS:
            return { ...state, warehouseBinsDetailIsLoading: true, warehouseBinsDetailError: null };
        case FETCH_WAREHOUSE_BINS_SUCCESS:
            return { ...state, warehouseBinsDetail: action.payload.data, warehouseBinsDetailIsLoading: false };
        case FETCH_WAREHOUSE_BINS_FAILURE:
            const warehouseBinsDetailError = action.payload.data || { message: action.payload.message };
            return { ...state, warehouseBinsDetailError: warehouseBinsDetailError, warehouseBinsDetailIsLoading: false };
        case REQUEST_DELETE_WAREHOUSE:
            return { ...state, deleteWarehouse: true, deleteWarehouseSuccess: null, deleteWarehouseError: null };
        case DELETE_WAREHOUSE_SUCCESS:
            return { ...state, deleteWarehouse: false, deleteWarehouseSuccess: true };
        case DELETE_WAREHOUSE_FAILURE:
            const deleteWarehouseError = action.payload.data || { message: action.payload.messge };
            return { ...state, deleteWarehouse: false, deleteWarehouseError: deleteWarehouseError };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/warehouses_reducer.js